import {
  CardStyleInterpolators,
  createStackNavigator,
} from "@react-navigation/stack";
import { ProductRootPartialScreenParamList } from "../../../../types";
import { ProductDetailScreen } from "../ProductDetailScreen";
import { ProductPreviewScreen } from "../ProductPreviewScreen";
import { useNavigation } from "@react-navigation/native";
import { View } from "react-native-ui-lib";
import {
  PartialPage,
  useThemeProvider,
} from "@towersystems/roam-common-native";

export const ProductRootPartialScreen = () => {
  const { colors } = useThemeProvider();
  const navigation = useNavigation<any>();
  const RootNavigator =
    createStackNavigator<ProductRootPartialScreenParamList>();

  return (
    <PartialPage
      scrollable={false}
      size="compact"
      onClose={() => navigation.goBack()}
      contentContainerStyle={{ flex: 1 }}
    >
      <View flex style={{ flex: 1, height: "100%" }}>
        <RootNavigator.Navigator
          screenOptions={{
            headerShown: false,
            cardStyle: { backgroundColor: colors.surface },
            animationEnabled: true,
            cardStyleInterpolator: CardStyleInterpolators.forHorizontalIOS,
          }}
        >
          <RootNavigator.Screen
            name="ProductDetailScreen"
            component={ProductDetailScreen}
          />
          <RootNavigator.Screen
            name="ProductPreviewScreen"
            component={ProductPreviewScreen}
          />
        </RootNavigator.Navigator>
      </View>
    </PartialPage>
  );
};
